import React from 'react';
import PropTypes from 'prop-types';
import {
  PrimaryButton,
  Stack,
  Text,
  IconButton,
  TooltipHost,
  Spinner,
  SpinnerSize,
  Icon,
} from '@fluentui/react';
import { Depths } from '@uifabric/fluent-theme';
import { useId } from '@uifabric/react-hooks';
import useRestartIngestorMutation from '../../hooks/useRestartIngestorMutation';
import theme from '../../../../theme.style';

export default function ReIngestProductsRecommendation() {
  const tooltipId = useId();
  const restartIngestorMutation = useRestartIngestorMutation();

  return (
    <Stack
      style={{ padding: 20, backgroundColor: 'white', boxShadow: Depths.depth4 }}
      tokens={{ childrenGap: 12 }}
    >
      <Text style={{ fontWeight: 'bold' }}>Rerun Expectations</Text>
      <Text style={{ fontWeight: 'normal' }}>
        Staging quantity is showing <span style={{ fontWeight: 'bold' }}>0</span>. This could happen
        because expectations hasn&apos;t run for this contract. Click the button below to re-run
        expectations for this contract, then give ingestor some time to re-run expectations (~10
        minutes or more). Once you are done waiting, click the submit button above once more. If the
        problem persists talk to an SME on the team.
      </Text>

      {restartIngestorMutation.error && (
        <Text style={{ fontWeight: 'normal', color: theme.palette.accentError }}>
          {restartIngestorMutation.error.response?.data?.message ||
            restartIngestorMutation.error.message}
        </Text>
      )}

      {restartIngestorMutation.isSuccess && (
        <Text style={{ fontWeight: 'normal', color: theme.palette.accentTeal }}>
          <Icon iconName="StatusCircleCheckmark" />
          Successfully restarted ingestor. Give ingestor some time (~10 minutes or so), then
          re-submit the form above. If the problem persists talk to an SME on the team.
        </Text>
      )}

      {restartIngestorMutation.isLoading && (
        <Text style={{ fontWeight: 'normal' }}>
          Hang tight, this may take some time...In the meantime, you can check out the progress{' '}
          <a
            href="https://microsoftit.visualstudio.com/OneITVSO/_release?_a=releases&view=mine&definitionId=8011"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
        </Text>
      )}

      <Stack horizontal tokens={{ childrenGap: 12 }}>
        <PrimaryButton
          disabled={restartIngestorMutation.isLoading}
          onClick={() => restartIngestorMutation.mutate()}
        >
          {restartIngestorMutation.isLoading ? (
            <Spinner size={SpinnerSize.xSmall} />
          ) : (
            'Rerun Expectations'
          )}
        </PrimaryButton>
        <TooltipHost
          content="This restarts ingestor which will update expectations for this contract."
          id={tooltipId}
          closeDelay={500}
        >
          <IconButton
            iconProps={{ iconName: 'Info' }}
            aria-describedby={tooltipId}
            ariaLabel="Info"
          />
        </TooltipHost>
      </Stack>
    </Stack>
  );
}

ReIngestProductsRecommendation.propTypes = {
  data: PropTypes.shape({}).isRequired,
};
